import {
  ArrowDownTrayIcon,
  BookmarkIcon,
  ChatBubbleBottomCenterIcon,
  ClipboardDocumentIcon,
  ClockIcon,
  CogIcon,
  HomeIcon,
  IdentificationIcon,
  LightBulbIcon,
  MusicalNoteIcon,
  QueueListIcon,
  RectangleGroupIcon,
  UsersIcon
} from '@heroicons/react/24/outline'
import { Fragment, useMemo } from 'react'
import { NavLink, useMatch } from 'react-router-dom'
import { NavigationItem } from '../../gql/graphql'
import { classNames } from '../_helpers'

type PropTypes = {
  item: NavigationItem,
  mobile?: boolean,
}

export const MenuItem = ({item, mobile}: PropTypes) => {
  const matchObject = useMatch(`${item.href}*`)
  const match = matchObject !== null && (matchObject.pathname === '/' || matchObject.pathnameBase !== '/')

  const icon = useMemo(() => {
    switch (item.icon) {
      case 'ArrowDownTrayIcon':
        return {component: ArrowDownTrayIcon}
      case 'ClipboardDocumentIcon':
        return {component: ClipboardDocumentIcon}
      case 'MusicalNoteIcon':
        return {component: MusicalNoteIcon}
      case 'ClockIcon':
        return {component: ClockIcon}
      case 'CogIcon':
        return {component: CogIcon}
      case 'HomeIcon':
        return {component: HomeIcon}
      case 'LightBulbIcon':
        return {component: LightBulbIcon}
      case 'QueueListIcon':
        return {component: QueueListIcon}
      case 'BookmarkIcon':
        return {component: BookmarkIcon}
      case 'RectangleGroupIcon':
        return {component: RectangleGroupIcon}
      case 'UsersIcon':
        return {component: UsersIcon}
      case 'ChatBubbleBottomCenterIcon':
        return {component: ChatBubbleBottomCenterIcon}
      case 'IdentificationIcon':
        return {component: IdentificationIcon}
      default:
        return {component: Fragment}
    }
  }, [item.icon])

  const active = match

  if (mobile) {
    return (
      <NavLink
        key={item.name}
        to={item.href || '/'}
        className={({isActive, isPending}) => classNames(
          (isActive || isPending || active)
            ? 'bg-white/15 text-white shadow-sm ring-1 ring-white/10'
            : 'text-white/70 hover:bg-white/10 hover:text-white',
          'group py-2.5 px-3 rounded-xl flex items-center text-sm font-medium transition-all duration-200'
        )}
      >
        <icon.component
          className="mr-3 h-6 w-6 shrink-0 transition-transform duration-200 group-hover:scale-110"
          aria-hidden="true"
        />
        <span>{item.name}</span>
      </NavLink>
    )
  }

  return (
    <NavLink
      key={item.name}
      to={item.href || '/'}
      className={({ isActive, isPending }) => classNames(
        (isActive || isPending || active)
          ? 'bg-white/15 text-white shadow-sm ring-1 ring-white/10'
          : 'text-white/70 hover:bg-white/10 hover:text-white',
        'group relative w-full px-2 py-3 rounded-xl flex flex-col items-center text-xs font-medium transition-all duration-200'
      )}
    >
      {active && (
        <span
          className="absolute -left-2 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-500"
          aria-hidden="true"
        />
      )}
      <icon.component
        className="h-6 w-6 transition-transform duration-200 group-hover:scale-110"
        aria-hidden="true"
      />
      <span className="mt-1.5 text-center text-[11px] leading-tight">
        {item.name}
      </span>
    </NavLink>
  )
}
